<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="500"
  >
    <v-card>
      <v-card-title>
        Scan QR Code
      </v-card-title>

      <v-card-text>
        <div id="qr-reader" style="width:100%"></div>

        <v-alert
          v-if="result"
          type="success"
          dense
          class="mt-3"
        >
          {{ result }}
        </v-alert>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn
          color="error"
          text
          @click="closeScanner"
        >
          Close
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { Html5Qrcode } from "html5-qrcode";

export default {
  data() {
    return {
      dialog: false,
      html5QrCode: null,
      result: ""
    };
  },

  methods: {
    openScanner() {
      this.dialog = true;

      this.$nextTick(() => {
        this.startScanner();
      });
    },

    async startScanner() {
      this.html5QrCode = new Html5Qrcode("qr-reader");

      await this.html5QrCode.start(
        {
          facingMode: "environment" // rear camera
        },
        {
          fps: 10,
          qrbox: 250
        },
        (decodedText) => {
          this.result = decodedText;

          this.$emit("scanned", decodedText);

          // Auto stop after successful scan
          this.closeScanner();
        },
        () => {
          console.log("ss")
        }
      );
    },

    async closeScanner() {
  if (this.html5QrCode) {
    try {
      await this.html5QrCode.stop();
      await this.html5QrCode.clear();
    } catch (e) {
      console.error("Failed to stop scanner:", e);
    }

    this.html5QrCode = null;
  }

  this.dialog = false;
}
  },

  beforeDestroy() {
    this.closeScanner();
  }
};
</script>